module.exports = __webpack_public_path__ + "static/img/bg-login.39239a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg-login.jpg
// module id = eavt
// module chunks = 1